export default __webpack_public_path__ + "img/5bbddca690a11b2cd917378f0883495b.mp4";